export const SUNDAE_GENERAL_TOAST_ID = "SUNDAE_GENERAL_TOAST_ID";
